<template>
  <div>
    <p>
      By ticking the box below, you confirm you understand the following. The
      leaseholder remains responsible for all utility charges, even where the
      property is sub-let. Any unpaid charges may be added to the service charge
      account.
    </p>

    <p>
      We’ll automatically contact all account holders by email, using the
      details provided. To request paper bills, please contact our Customer Care
      Team via the Resident Hub.
    </p>

    <p>
      Please report all move-ins and move-outs within 30 days via the Customer
      Portal. If not, a discretionary £30 (including VAT) administration fee
      will be charged to the leaseholder or letting agent.
    </p>
  </div>
</template>

<script>
export default {
  name: "ActionsAndHelpTerms"
};
</script>

<style scoped lang="scss">
p {
  font-size: 0.9rem;
  color: #666;
}

div {
  margin-top: 20px;
}
</style>
